import styled from '@emotion/styled'
import { Box, Modal, List, EntryRow } from 'stylewhere/components'
import { SimpleReadingListBatchValidateResEntry } from 'stylewhere/api'
import { T, __ } from 'stylewhere/i18n'
import { SimpleReadingListOperationConfig } from 'stylewhere/shared'

interface Props {
  title?: string
  isOpen: boolean
  entries: SimpleReadingListBatchValidateResEntry[]
  operation: SimpleReadingListOperationConfig
  onClose: () => void
}

export const EntryListModal: React.FC<Props> = ({
  title = __(T.misc.product_items),
  isOpen,
  onClose,
  entries,
  operation
}) => {
  if (!isOpen) return null
  const rowRender = (data: SimpleReadingListBatchValidateResEntry) => {
    const showCounters = operation.targetEntity === 'products' || operation.targetEntity === 'NONE'

    return (
      <EntryRow
        row={data}
        operation={operation}
        hasChecklist={operation.hasChecklist}
        showCounters={showCounters}
        targetEntity={operation.targetEntity}
      />
    )
  }

  return (
    <Modal visible={isOpen} onClose={onClose} size="4xl" closeOnOverlayClick>
      <Box height="70vh">
        <Title>
          {title} ({entries?.length ?? 0})
        </Title>
        <Box flex>
          <List
            data={entries}
            emptyMessage={<span style={{ whiteSpace: 'break-spaces' }}>{__(T.messages.list_empty)}</span>}
            rowRender={rowRender}
          />
        </Box>
      </Box>
    </Modal>
  )
}

const Title = styled.h2`
  font-size: 26px;
  font-weight: bold;
  margin-bottom: 25px;
`
